import type { App as AppType } from 'vue'
import { Icon as IconIfy } from '@iconify/vue'

export default {
  install: (Vue: AppType) => {
    Vue.component('IconIfy', IconIfy)
  }
}
